import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { LandingNav } from '@/routes/-landing/nav'
import { Footer } from '@/routes/-landing/footer'

// Per-page chrome config, declared on each child route's `staticData` and read here. `hideFooter`: docs is the lone
// full-bleed page with no footer.
type LandingStaticData = {
  hideFooter?: boolean
}

export const Route = createFileRoute('/_landing')({
  component: LandingLayout,
  // A SHELL, like _app: never pends, stays in the entry bundle (5 KB gzip), so the page under it paints its own.
  codeSplitGroupings: [['errorComponent'], ['notFoundComponent']],
})

/**
 * The docs and the policy pages, under the landing's own top bar and footer. They carry no sections of their own, so
 * the bar comes up without them (see `LandingNav`).
 */
function LandingLayout() {
  const matches = useMatches()
  // staticData is typed as the generic StaticDataRouteOption; assert our per-page shape.
  // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
  const config = matches.at(-1)?.staticData as LandingStaticData | undefined

  return (
    <>
      <LandingNav />
      <Outlet />
      {!config?.hideFooter && <Footer />}
    </>
  )
}
